module.exports = __webpack_public_path__ + "static/media/tortuga-club-desktop.e40b0621.jpg";